import axios from 'axios'
import store from '@/store'
// import router from '@/router'
import { getToken } from '@/utils/auth'
import { Message } from 'element-ui'
import commonStore from '@/store/common.js'
const request = axios.create()
request.defaults.timeout = 600000 // 默认超时时间
request.defaults.validateStatus = status => status >= 200 && status <= 500 // 返回true，promise将被resolve，返回false，promise将被reject
request.defaults.withCredentials = true // 跨域请求，允许保存cookie

// 请求拦截
request.interceptors.request.use(
  config => {
    const meta = config.meta || {}
    const isToken = meta.isToken === false
    config.headers.Authorization = 'Basic c2FiZXI6c2FiZXJfc2VjcmV0'
    const isTraditional = commonStore.state.langType === 's' ? 0 : 1
    config.headers.isTraditional = isTraditional
    if (getToken() && !isToken) {
      // 让每个请求携带token--['Authorization']为自定义key 请根据实际情况自行修改
      config.headers['Blade-Auth'] = 'bearer ' + getToken()
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截
request.interceptors.response.use(
  res => {
    // 获取状态码
    const status = res.data.code || res.status
    let message = res.data.msg || res.data.error_description || '未知错误'
    // 如果是401则跳转到登录页面
    if (status === 401) {
      store.dispatch('FedLogOut')
      store.commit('SET_LOGIN_DIALOG', true)
      // message = '未登录，请前往登录！'
      // MessageBox.confirm(message, '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // })
      //   .then(() => {
      //     store.dispatch('FedLogOut').then(() => {
      //       if (router.currentRoute.fullPath !== '/login') {
      //         window.sessionStorage.setItem('urlAfterLogin', window.location.href) // 记下当前在哪个页面，登录状态失效后重新登录，就跳转到这个页面来
      //       }
      //       return Promise.reject(new Error('未授权'))
      //     })
      //     router.replace('/login')
      //   })
      //   .catch(() => {})

      return
    }
    // 如果请求为非200否者默认统一处理
    if (status !== 200) {
      Message({
        message,
        type: 'error',
        duration: 3000
      })
      return Promise.reject(new Error(message))
    }
    return res
  },
  error => {
    return Promise.reject(new Error(error))
  }
)

export default request
